import dates from "@/helpers/dates";
import files from "@/helpers/files";
import forms from "@/helpers/forms";
import quill from "@/helpers/quill";
import requests from "@/helpers/requests";

export default {
  dates,
  files,
  forms,
  quill,
  requests,
};
